/* there is must be "stppg" class on "form-item-wrap" element */
$('.mdl').on(
  'click',

  function () {
    $('.jq-selectbox').removeClass('opened');
    $('.jq-selectbox__dropdown').css('display', 'none');
  }
);
